module.exports = __webpack_public_path__ + "img/wiping-sprayer.211431f1.svg";